import { getColor } from '../../../../theme-tools';
import { inputBaseStyles } from '../commonBasedStyles';
var getVariantOutline = props => {
  var {
    theme
  } = props;
  var {
    base,
    focus,
    disabled,
    invalid,
    invalidFocus
  } = inputBaseStyles;
  return {
    borderColor: base.borderColor,
    borderRadius: base.borderRadius,
    letterSpacing: '-0.2px',
    padding: '10px 16px',
    maxHeight: '31.25rem',
    _placeholder: {
      color: base.placeHolderColor
    },
    _focus: {
      borderColor: focus.borderColor,
      boxShadow: "0 0 4px 1px ".concat(getColor(theme, focus.boxShadowColor))
    },
    _disabled: {
      backgroundColor: disabled.bg,
      borderColor: disabled.borderColor,
      color: disabled.color
    },
    _invalid: {
      borderWidth: invalid.borderWidth,
      borderColor: invalid.borderColor,
      boxShadow: 'none',
      _focus: {
        borderColor: invalidFocus.borderColor,
        boxShadow: "0 0 4px 1px ".concat(getColor(theme, invalidFocus.boxShadowColor)),
        outline: 'none'
      }
    }
  };
};
export var Textarea = {
  variants: {
    outline: getVariantOutline
  }
};